module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('h1', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("The Problem of Other Minds")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("What do we learn when you take me to you?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I want to discover all that we can,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Since coupling divides as well as unites.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Neither of us knows what the other feels.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("We just decipher signs … if we notice …")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And how can you be sure you got them right?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("If it’s not going down, whose fault is that?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("You’ll shoot back, ‘That’s a man talking, all right’.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But, wait! Hold on. Tell me, how do you judge?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Since, unlike the body, the brain’s intact,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Not to be breached by foolproof probes, and live?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("We lie every day about what we feel.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("We live in a bubble of assumptions,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Or try to anyway, inferring likeness—")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("One like another?—day in and day out,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("But likeness is a worn, often shabby")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Garment that hides implacable hatred")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("As old as pissing to mark a thing yours.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("‘The problem of other minds,’ philosophy")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Has taught us to call it. Most of us laugh,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Or at any rate smile—why should we care?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Each will take what he or she wants, and some")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Won’t think twice about killing for it—")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Murder pleases so many so fully")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("It’s a blunder we don’t rename it ‘god’")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And replace our churches with armories,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Sunday School with Gun-day School—prey for all!")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Even god is murdered, by both church and state.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Still called ‘The Son of Man’, and by his Abba called,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("He knew the answer to being apart:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Not just seven but seventy times seven,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Not just between us but between us all—")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Forgiveness is love’s imperfect knowledge.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee290b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781645367314_EPUB-8.vue
// module id = 81
// module chunks = 0